angular.module 'zc.projects.reports'

.controller 'ReportCtrl', ($scope, $state, $q, $translate, Project, Page, Report, ReportCampaignStats, Campaign, ReportRange, Devise, currentProject, currencies) ->
  Page.setBodyClass ''
  $translate('projectsReports.controllers.show.repooto_shousai').then((translation) ->
    Page.setTitle(translation)
  )

  CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM = moment('2017/05/01', 'YYYY/MM/DD')

  $scope.Project = Project
  $scope.Devise = Devise
  $scope.Report = Report
  $scope.currentProject = currentProject
  $scope.currency = currencies[currentProject.currency]
  $scope.campaigns = []
  $scope.isAb = false

  begin_at = new Date(parseInt($state.params.reportId))
  $scope.status = $state.params.status
  $scope.can_show_zenclerk_lp_invoice_amount = moment(begin_at).isSameOrAfter(CAN_SHOW_ZENCLERK_LP_INVOICE_AMOUNT_FROM)

  $scope.showList = ->
    $state.go 'admin.projects.reports', {projectId: $state.params.projectId}

  $scope.prevMonth = moment(begin_at).tz(currentProject.region).subtract(1, 'month').toDate()
  $scope.showPrevMonth = ->
    reportId = $scope.prevMonth.valueOf()
    $state.go 'admin.projects.reports.show', {projectId: $state.params.projectId, reportId: reportId}

  $scope.nextMonth = moment(begin_at).tz(currentProject.region).add(1, 'month').toDate()
  $scope.showNextMonth = ->
    reportId = $scope.nextMonth.valueOf()
    $state.go 'admin.projects.reports.show', {projectId: $state.params.projectId, reportId: reportId}

  if ReportRange.isLatest(begin_at)
    $scope.isLatest = true
    dimension = 'daily'
  else
    $scope.isLatest = false
    dimension = 'monthly'

  Report.findOne
    apikey: currentProject.apikey
    dimension: dimension
  ,
    match:
      target: null
      device: null
      status: $scope.status
      begin_at: begin_at
    sort:
      end_at: -1
  .then (report_stats) ->
    return if !report_stats

    ReportCampaignStats.find
      apikey: currentProject.apikey
      dimension: dimension
      campaign_id:
        '$in': report_stats.campaign_ids
    ,
      match:
        status: $scope.status
        begin_at: new Date(report_stats.begin_at)
        start_at: new Date(report_stats.start_at) if report_stats.start_at
        end_at: new Date(report_stats.end_at)
    .then (report_campaigns) ->
      return if _.has(report_campaigns, '0.all_experimental')

      report_stats.all_experimental = {
        conversion_price: _.sumBy report_campaigns, 'experimental.conversion_price'
        conversion_count: _.sumBy report_campaigns, 'experimental.conversion_count'
      }


    $scope.report = report_stats
    $scope.filters = {dimension, begin_at, status: $scope.status, start_at: report_stats.start_at}
    promises = for campaign_id in $scope.report.campaign_ids
      Campaign.get
        projectId: currentProject.id
        campaignId: campaign_id
    $q.all(promises).then (campaigns) ->
      $scope.campaigns = campaigns
      $scope.isAb = _.some $scope.campaigns, (campaign) ->
        campaign.campaign_control_percent isnt 0 and not campaign.is_secret_ab



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.reports/show.controller.js.coffee